import module from 'usuario/module.js'
import template from './template.html'
import moment from 'moment'

export class UsuarioComponent {
  UsuarioEstatus = false
  UsuarioDesvincular = false
  usuarioId = null
  data = {
    activo: true,
    apellidos: '',
    duracion: 0,
    acceso_fecha: null,
    id: null,
    idioma: null,
    master: false,
    nombre: '',
    vinculo: false,
    puesto: '',
    rol: undefined,
    telefono: '',
    usuario: '',
  }

  $onInit () {
    this.data.ultimo_acceso = this.data.acceso_fecha ? moment(this.data.acceso_fecha).format('LL [a las] LT') : null;
  }

  activar () {
    this.activarUsuario = true
  }

  estatus () {
    this.UsuarioEstatus = true
  }

  activo (value) {
    this.activarUsuario = false
    if (value) {
      this.data.activo = true
    }
  }

  desvincular () {
    this.UsuarioDesvincular = true
  }

  cerrar (termino) {
    this.UsuarioDesvincular = false
    if (termino) {
      this.data.vinculo = null
    }
  }
}

module.component('usuario', {
  controller: UsuarioComponent,
  template,
  bindings: {
    usuarioId: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/usuario/components/component.js